var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPorfolioarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 26,
    viewBox: "0 0 92 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1727_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6925 12.6709C83.6046 12.6709 78.752 8.35735 78.752 0",
    stroke: "#56453F",
    strokeWidth: 2.68682
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6944 12.6719C83.6066 12.6719 78.7539 16.9854 78.7539 25.3427",
    stroke: "#56453F",
    strokeWidth: 2.68682
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9227 12.5469L35.5508 12.5469",
    stroke: "#56453F",
    strokeWidth: 2.68682
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.6945,
    height: 25.3413,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorfolioarrow);
export default __webpack_public_path__ + "static/media/porfolioarrow.8274593cec672da2b33e24b9ba52da7d.svg";
export { ForwardRef as ReactComponent };